import { markNetworkFailure, markNetworkSuccess } from './connectivity.js';

/** @typedef {'idle' | 'refreshing' | 'downloading' | 'stale' | 'offline' | 'fresh'} SyncStatus */

/** @type {{ status: SyncStatus, cachedAt: string | null, listeners: Set<() => void> }} */
const syncState = {
  status: 'idle',
  cachedAt: null,
  listeners: new Set(),
};

export function getSyncState() {
  return { status: syncState.status, cachedAt: syncState.cachedAt };
}

export function setSyncStatus(status, cachedAt = syncState.cachedAt) {
  syncState.status = status;
  if (cachedAt !== undefined) syncState.cachedAt = cachedAt;
  for (const fn of syncState.listeners) fn();
}

export function onSyncStatusChange(listener) {
  syncState.listeners.add(listener);
  return () => syncState.listeners.delete(listener);
}

/**
 * Race a promise against a timeout. Rejects with TimeoutError on expiry.
 * @template T
 * @param {Promise<T>} promise
 * @param {number} [ms=5000]
 * @returns {Promise<T>}
 */
export async function fetchWithTimeout(promise, ms = 5000) {
  let timer;
  const timeout = new Promise((_, reject) => {
    timer = setTimeout(() => {
      const err = new Error('Timeout di rete');
      err.name = 'TimeoutError';
      err.code = 'TIMEOUT';
      reject(err);
    }, ms);
  });

  try {
    const result = await Promise.race([promise, timeout]);
    markNetworkSuccess();
    return result;
  } catch (err) {
    if (err?.name === 'TimeoutError' || err?.code === 'TIMEOUT') {
      markNetworkFailure();
    }
    throw err;
  } finally {
    clearTimeout(timer);
  }
}
